<!-- <div *ngIf="appBusy" class="spinner-section">
<mat-progress-spinner class="spinner" color="primary" mode="indeterminate"> </mat-progress-spinner>
</div> -->

<form [formGroup]="regFormGroup" class="kcFormClass" autocomplete="off">

  <mat-form-field style="width: -webkit-fill-available">
    <input matInput placeholder="Email" formControlName="email" maxlength="50" type="email" required style="box-shadow: none;">
    @if (regFormGroup.controls.email.hasError('required')) {
      <mat-error>
        {{'reg.emailRequired' | translate}}
      </mat-error>
    }
    @if (!regFormGroup.controls.email.hasError('required') && regFormGroup.controls.email.hasError('pattern')) {
      <mat-error>
        {{'reg.invalidEmail' | translate}}
      </mat-error>
    }
  </mat-form-field>

  @if (regFor==='Supplier') {
    <mat-form-field style="width: -webkit-fill-available">
      <input matInput placeholder="Company Name" formControlName="orgName" maxlength="50" required style="box-shadow: none;">
      @if (regFormGroup.controls.orgName.hasError('required')) {
        <mat-error>
          {{'reg.orgNameRequired' | translate}}
        </mat-error>
      }
      @if (!regFormGroup.controls.orgName.hasError('required') && regFormGroup.controls.orgName.hasError('pattern')) {
        <mat-error>
          {{'reg.invalidOrgname' | translate}}
        </mat-error>
      }
    </mat-form-field>
  }

  @if (regFor==='Individual') {
    <mat-form-field style="width: -webkit-fill-available">
      <input matInput placeholder="First Name" formControlName="firstName" maxlength="50" required style="box-shadow: none;">
      @if (regFormGroup.controls.firstName.hasError('required')) {
        <mat-error>
          {{'reg.firstNameRequired' | translate}}
        </mat-error>
      }
      @if (!regFormGroup.controls.firstName.hasError('required') && regFormGroup.controls.firstName.hasError('pattern')) {
        <mat-error>
          {{'reg.invalidFirstName' | translate}}
        </mat-error>
      }
    </mat-form-field>
  }
  @if (regFor==='Individual') {
    <mat-form-field style="width: -webkit-fill-available">
      <input matInput placeholder="Last Name" formControlName="lastName" maxlength="50" required style="box-shadow: none;">
      @if (regFormGroup.controls.lastName.hasError('required')) {
        <mat-error>
          {{'reg.lastNameRequired' | translate}}
        </mat-error>
      }
      @if (!regFormGroup.controls.lastName.hasError('required') && regFormGroup.controls.lastName.hasError('pattern')) {
        <mat-error>
          {{'reg.invalidLastName' | translate}}
        </mat-error>
      }
    </mat-form-field>
  }

  <mat-form-field style="width: -webkit-fill-available">
    <input matInput placeholder="Contact Number" formControlName="contactNumber" required pattern="^.{9,13}$" maxlength="13"
      style="box-shadow: none;">
    @if (regFormGroup.controls.contactNumber.hasError('required')) {
      <mat-error>
        {{'reg.mobileRequired' | translate}}
      </mat-error>
    }
    @if (!regFormGroup.controls.contactNumber.hasError('required') && regFormGroup.controls.contactNumber.hasError('pattern')) {
      <mat-error>
        {{'reg.invalidMobileNumber' | translate}}
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field style="width: -webkit-fill-available">
    <input matInput placeholder="Password" formControlName="password" maxlength="50" type="password" required style="box-shadow: none;">
    @if (regFormGroup.controls.password.hasError('required')) {
      <mat-error>
        {{'reg.passwordRequired' | translate}}
      </mat-error>
    }
    @if (!regFormGroup.controls.password.hasError('required') && regFormGroup.controls.password.hasError('minlength')) {
      <mat-error>
        {{'reg.invalidPassword' | translate}}
      </mat-error>
    }
  </mat-form-field>

  @if (gCaptchaEnabled) {
    <div style="margin-bottom:10px;">
      <re-captcha (resolved)="resolved($event)" [siteKey]="siteKey"></re-captcha>
    </div>
  }
  <div>
    <button mat-raised-button color="primary" type="submit" (click)="register()" style="float: right;" [disabled]="appBusy">
      {{'reg.submit' |translate }}
    </button>
  </div>




</form>
